import store from '../../../Store/index';
import { ls as storage } from '../../../Helpers/LocalStorage';
import React from 'react';
import {
   CALLKIT_CALLSTATUS,
   AUDIO_CALL_PERMISSION_DENIED_CODE,
   AUDIO_CALL_PERMISSION_DENIED_MSG,
   VIDEO_CALL_PERMISSION_DENIED_CODE,
   VIDEO_CALL_PERMISSION_DENIED_MSG,
   CALLKIT_CALLSCREENSTATUS,
} from '../constants';
import { showPopup } from './popupService';
import MicrophonePermissionPopup from '../ui/components/PermissionPopup/MicrophonePermissionPopup';
import CameraPermissionPopup from '../ui/components/PermissionPopup/CameraPermissionPopup';
import { locale as i18n } from '../../../Helpers/Locale/Index';
import { showInfoToast } from './toastMessage';
import SDK from '../../../Components/SDK';
import { setUserInfoArr } from '../../../Slice/userInfoSlice';


export const CALLKIT_STATUS_MAP = {
   [CALLKIT_CALLSTATUS.RINGING]: 'RINGING',
   [CALLKIT_CALLSTATUS.CONNECTING]: 'CONNECTING',
   [CALLKIT_CALLSTATUS.CONNECTED]: 'CONNECTED',
   [CALLKIT_CALLSTATUS.DISCONNECTED]: 'DISCONNECTED',
   [CALLKIT_CALLSTATUS.REJECTED]: 'BUSY',
   [CALLKIT_CALLSTATUS.ENGAGED]: 'ENGAGED',
   [CALLKIT_CALLSTATUS.TIMEOUT]: 'TIME_OUT',
   [CALLKIT_CALLSTATUS.CALLING]: 'CALLING',
   [CALLKIT_CALLSTATUS.TRY_TO_CONNECT]: 'TRYING_TO_CONNECT',
   [CALLKIT_CALLSTATUS.RECONNECTING]: 'RECONNECTING',
};

export const getCallStatusLabel = (status, t) => {
   const key = CALLKIT_STATUS_MAP[status];
   return key ? t(`calls.STATUS.${key}`) : status;
};

export const getCallUserById = userId => {
   const users = store.getState().callkitData.ongoingCallParticipants;
   return users.find(user => user.userId && userId && (user.userId === userId || user.userId.split('@')[0] === userId.split('@')[0]));
};

export const isMatchingUserId = (id1, id2) => {
   if (!id1 || !id2) return false;
   return id1 === id2 || id1.split('@')[0] === id2.split('@')[0];
};

export const getLocalUserName = () => {
   const vCardData = store.getState().vCardData;
   return vCardData?.data?.fromUser || storage.getItem('username');
};

export const isOwnUserReconnecting = () => {
   const currentUserId = getLocalUserName();
   const { ongoingCallParticipants } = store.getState().callkitData;
   const localUser = ongoingCallParticipants.find(p => p.userId && currentUserId && (p.userId === currentUserId || p.userId.split('@')[0] === currentUserId.split('@')[0]));
   return localUser?.callStatus === CALLKIT_CALLSTATUS.RECONNECTING;
};

export const getCallMode = () => {
   const { callMode } = store.getState().callkitData;
   return callMode;
};

export const handleCallError = err => {
   if (err?.statusCode === AUDIO_CALL_PERMISSION_DENIED_CODE || err?.message === AUDIO_CALL_PERMISSION_DENIED_MSG) {
      showPopup({
         id: 'micPermissionPopup',
         visible: true,
         hideHeader: true,
         className: 'mic-permission-modal',
         body: React.createElement(MicrophonePermissionPopup),
      });
      return true;
   } else if (
      err?.statusCode === VIDEO_CALL_PERMISSION_DENIED_CODE ||
      err?.message === VIDEO_CALL_PERMISSION_DENIED_MSG
   ) {
      showPopup({
         id: 'cameraPermissionPopup',
         visible: true,
         hideHeader: true,
         className: 'camera-permission-modal',
         body: React.createElement(CameraPermissionPopup),
      });
      return true;
   }
   return false;
};

export const fetchUsersInfo = userIds => {
   if (!Array.isArray(userIds) || userIds.length === 0) return;
   const { getUsersProfile } = SDK;
   getUsersProfile(userIds, (success, err) => {
      if (success) {
         store.dispatch(setUserInfoArr(success.data));
      }
   });
};

export const isAlreadyInCall = () => {
   const { callScreenStatus } = store.getState().callkitData;
   const isActive =
      callScreenStatus &&
      callScreenStatus !== CALLKIT_CALLSCREENSTATUS.ENDED &&
      callScreenStatus !== CALLKIT_CALLSCREENSTATUS.IDLE;
   if (isActive) {
      showInfoToast(i18n.t('calls.ALREADY_IN_A_CALL', { defaultValue: 'You are already in a call' }));
      return true;
   }
   return false;
};

export const resolveCallUserName = (userId) => {
   if (!userId) return '';
   const state = store.getState();
   const users = state.userInfoData?.users || {};
   const rosterData = state.rosterData?.data || [];
   const user = users[userId] || {};
   const id = userId.split('@')[0];

   // Tiered resolve logic (same as in Common/index.jsx)
   let rosterUser = rosterData.find(r => r && (r.userId === id || r.userId === userId));
   if (!rosterUser) {
      const userPhone = (user.userId || user.username || user.mobileNumber || '').split('@')[0];
      if (userPhone && userPhone !== id) {
         rosterUser = rosterData.find(r => {
            const rid = r?.userId?.split('@')[0];
            return rid && rid.length >= 7 && userPhone.length >= 7 && (rid.endsWith(userPhone) || userPhone.endsWith(rid));
         });
      }
   }
   if (!rosterUser) {
       rosterUser = rosterData.find(r => {
          const rid = r?.userId?.split('@')[0];
          return rid && id && rid.length >= 7 && id.length >= 7 && (rid.endsWith(id) || id.endsWith(rid));
       });
   }

   return (rosterUser?.name || rosterUser?.displayName || rosterUser?.nickName || user.nickName || user.name || userId || '');
};
